export const BrightLabsCredit = () => (
  <a
    href="https://brightlabs.live/"
    target="_blank"
    rel="noreferrer noopener"
    data-testid="brightlabs-credit-link"
    className="group inline-flex items-center gap-2 whitespace-nowrap text-xs text-white/95 transition-colors hover:text-white"
  >
    <span>Designed &amp; built by</span>
    <img
      src="/brand/brightlabs-white.png"
      alt="BrightLabs"
      data-testid="brightlabs-logo"
      className="h-5 w-auto opacity-90 sm:h-[22px] transition-all duration-300 group-hover:-translate-y-0.5 group-hover:opacity-100"
    />
  </a>
);

export default BrightLabsCredit;
